<div class="container" role="main">
    <div class="HmsContainer">
        <div class="row">
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to Previous
                        Section</button>
                    <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                        style="font-weight : bold;">Instructions</button>
                    <button type="button" class="orangeBtn ml-5" (click)="addInvolvedParty(false)" *ngIf="addAnotherInvolvedParty != 'No' && !showSaveButton" [disabled]="!isFormsValid"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
                    </button>
                    <button type="button" class="orangeBtn ml-5" (click)="addInvolvedParty(true)" *ngIf="addAnotherInvolvedParty != 'No' && showSaveButton" [disabled]="!isFormsValid"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Save
                    </button>
                    <button type="button" class="orangeBtn ml-5" (click)="submitInvolvedParties()" *ngIf="addAnotherInvolvedParty != '' && addAnotherInvolvedParty == 'No' && !showSaveButton"
                        [ngStyle]="{'background-color': primaryColor}">Finish Involved Party Selection and Proceed to Next Section
                    </button>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-md-12">
                    <p role="heading" aria-level="1">Additional Involved Parties</p>
                </div>
                <div class="col-sm-12">
                    <span class="col-sm-2 fs-14">Indicate if there are additional parties involved in this referral. Please note, you can edit and remove additional subjects. You cannot delete the primary subject but can edit as desired.</span>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-md-12 involvedPartyContainer">
                    <p role="heading" aria-level="1">Saved Parties ({{involvedPartyList.length + 1}})</p>
                    <div class="involvedPartyDetails">
                        <div class="col-md-11">
                            <p role="heading" aria-level="1">Primary Involved Party: {{primaryInvolveParty.subjectType}}</p>
                            <p class="fs-14">{{primaryInvolveParty.organization}}</p>
                            <p class="fs-14">External Referrring Party: {{primaryInvolveParty.isExternalReferal ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="col-md-1" [ngStyle]="{'margin-top': (primaryInvolveParty.organization == null || primaryInvolveParty.organization.trim() == '') ? '15px' : '25px'}">
                            <button type="button" class="greyBtn" style="font-weight : bold;" (click)="onEditAdditionalInvolvedParty(primaryInvolveParty)" [disabled]="showSaveButton">Edit</button>
                        </div>
                    </div>
                    <div class="involvedPartyDetails" *ngFor="let item of involvedPartyList; let i= index">
                        <div class="col-md-10">
                            <p role="heading" aria-level="1">Involved Party {{i + 1}}: {{item.subjectType}}</p>
                            <p class="fs-14">{{item.organization}}</p>
                            <p class="fs-14">External Referrring Party: {{item.isExternalReferal ? 'Yes' : 'No'}}</p>
                        </div>
                        <div class="col-md-2" [ngStyle]="{'margin-top': (item.organization == null || item.organization.trim() == '') ? '15px' : '25px'}">
                            <button type="button" class="greyBtn" style="font-weight : bold;margin-right: 10px;margin-left: 25px;" (click)="onDeleteAdditionalInvolvedParty(item)" [disabled]="showSaveButton">Delete</button>
                            <button type="button" class="greyBtn" style="font-weight : bold;" (click)="onEditAdditionalInvolvedParty(item)" [disabled]="showSaveButton">Edit</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="userForm" [formGroup]="anotherInvolvedPartyFormPart">
                        <div class="col-md-10" >
                            <app-json-form [controlsData]="anotherInvolvedPartyControl" [formData]="anotherInvolvedPartyFormPart"
                                (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty == 'Yes'">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="userForm" [formGroup]="involvedPartyFormPart">
                        <div class="col-md-10" >
                            <app-json-form [controlsData]="involvedPartyControl"
                                [formData]="involvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="9"
                                [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                                (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty == 'Yes' && involvedPartyTypeSelected">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <form class="userForm" [formGroup]="externalInvolvedPartyFormPart">
                        <div class="col-md-10" >
                            <app-json-form [controlsData]="externalInvolvedPartyControl" [formData]="externalInvolvedPartyFormPart"
                                (valueChangeEvent)="valueChange($event)"></app-json-form>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row HmsInsideContainer" style="padding: 0;" *ngIf="addAnotherInvolvedParty == 'Yes' && isExternalReferringParty != ''">
                <app-provider-details *ngIf="profileMasterTypeKey === 1" (formValidationEvent)="formValidationEvent($event)"></app-provider-details>
                <app-member-details *ngIf="profileMasterTypeKey === 2" (formValidationEvent)="formValidationEvent($event)"></app-member-details>
                <app-non-enumerated-provider-details *ngIf="profileMasterTypeKey === 3" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-provider-details>
                <app-non-enumerated-organization-details *ngIf="profileMasterTypeKey === 4" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-organization-details>
                <app-non-enumerated-individual-details *ngIf="profileMasterTypeKey === 5" (formValidationEvent)="formValidationEvent($event)"></app-non-enumerated-individual-details>
            </div>
            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty == 'Yes' && isExternalReferringParty == 'Yes'">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <form class="userForm" [formGroup]="additionalInvolvedPartyFormPart">
                        <app-json-form [controlsData]="additionalInvolvedPartyControl"
                            [formData]="additionalInvolvedPartyFormPart" [textAreaCol]="30" [textAreaRows]="2"
                            [textAreaCounterPositionClass]="'pull-left'" [showTextInfo] = "false"
                            (valueChangeEvent)="valueChange($event)"></app-json-form>
                    </form>
                </div>
            </div>

            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty != 'No' && !showSaveButton">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button type="button" class="orangeBtn pull-right" (click)="addInvolvedParty(false)" [disabled]="!isFormsValid"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Continue with Involved Party Selection
                    </button>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty != 'No' && showSaveButton">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button type="button" class="orangeBtn pull-right" (click)="addInvolvedParty(true)" [disabled]="!isFormsValid"
                        [ngStyle]="{'background-color': isFormsValid ? primaryColor : 'gray'}">Save
                    </button>
                </div>
            </div>
            <div class="row HmsInsideContainer" *ngIf="addAnotherInvolvedParty != '' && addAnotherInvolvedParty == 'No' && !showSaveButton">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <button type="button" class="orangeBtn pull-right" (click)="submitInvolvedParties()"
                        [ngStyle]="{'background-color': primaryColor}">Finish Involved Party Selection and Proceed to Next Section
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>